import * as React from "react";
import { Partner } from "../../../../../../store/Partners/Types";
import { ThemeShadowSizes, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { FieldSet } from "@vwpfs/mary-air-lib/components/air/06-molecules/FieldSet";
import { Form } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface Props {
    general: Partner;
}
/**
 *
 * @param props
 */
export const GeneralView: React.FC<Props> = (props: Props) => (
    <React.Fragment>
        <Div theme={{ shadow: ThemeShadowSizes.TINY }}>
            <Container
                theme={{
                    palette: ThemePalette.CONTRAST_PRIMARY,
                    padding: {
                        "": { y: 3 },
                        "sm": { y: 4 },
                    },
                }}
            >
                <Form>
                    <FieldSet title="Partner info">
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Name"
                                    value={props.general.name}
                                    asSummary
                                />
                            </Grid>

                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Partner number"
                                    value={props.general.partnerNumber}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Partner number (PAH)"
                                    value={props.general.partnerNumberPah}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Partner Type"
                                    value={props.general.partnerType}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                    </FieldSet>
                    {
                        (props.general.invoiceBalance !== 0 ||
                                props.general.claimBalance !== 0 ||
                                props.general.totalBalance !== 0) &&
                            <FieldSet title="Wallet">
                                <Div className="scl-b-row">
                                    <Grid
                                        size={{ xs: 12, md: 3 }}
                                    >
                                        <FormField
                                            label="Invoice Balance"
                                            value={props.general.invoiceBalance}
                                            asSummary
                                            type={FieldTypes.CurrencyDisplay}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 3 }}
                                    >
                                        <FormField
                                            label="Claim Balance"
                                            value={props.general.claimBalance}
                                            asSummary
                                            type={FieldTypes.CurrencyDisplay}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 3 }}
                                    >
                                        <FormField
                                            label="Total Balance"
                                            value={props.general.totalBalance}
                                            asSummary
                                            type={FieldTypes.CurrencyDisplay}
                                        />
                                    </Grid>
                                </Div>
                            </FieldSet>
                    }
                    {(props.general.iban || props.general.bic) &&
                            <FieldSet title="Bank">
                                <Div className="scl-b-row">
                                    <Grid
                                        size={{ xs: 12, md: 3 }}
                                    >
                                        <FormField
                                            type={FieldTypes.Text}
                                            label="IBAN"
                                            value={props.general.iban}
                                            asSummary
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 3 }}
                                    >
                                        <FormField
                                            type={FieldTypes.Text}
                                            label="BIC"
                                            value={props.general.bic}
                                            asSummary
                                        />
                                    </Grid>
                                </Div>
                            </FieldSet>
                    }
                    <FieldSet title="Contact">
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Email"
                                    value={props.general.email}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Address line 1"
                                    value={props.general.addressLine1}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Address line 2"
                                    value={props.general.addressLine2}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Zip code"
                                    value={props.general.zipCode}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="House number"
                                    value={props.general.houseNumber}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="House number"
                                    value={props.general.houseNumberAddition}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 3 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Residence"
                                    value={props.general.residence}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                    </FieldSet>
                </Form>
            </Container>
        </Div>
    </React.Fragment>
);
